export default __webpack_public_path__ + "1551f4f60c37af51121f106501f69b80.woff2";